<template>
    <div v-if="Show" class="item" @click="onClick">
        <div @click.stop="innerClick">
            <slot></slot>
        </div>
    </div>
</template>
<script>


export default {
    name: 'overlay',
    props: {
        Show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: this.Show
        }
    },
    methods: {
        onClick(e) {
            this.show = false
            this.$emit('click', { e });
        },
        innerClick() {
            console.log('Inner click event');
            return
        }
    }
}
</script>

<style lang="scss">
.item {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(68, 64, 64, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/components/overlay.vue